import React from "react";

import Editor from './ABridTimerEditor'
import EditorWrapper from '../../EditorWrapper'

import BridTile from "../../common/BridTile";
import EmptyArticle from "../../common/EmptyArticle";
import Timer from '../../common/Timer'

const ABridTimer = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.time = settings.time;
    // props.onRegisterBox(props.blockId, props.id, 'title_normal')

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <Timer finishTime={article.time} />
        </div>
    );
};

export default ABridTimer;
